import {
    Box,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Spinner,
    Text
} from '@chakra-ui/react'
import { Link } from 'react-router-dom';

import React, { Fragment } from 'react'
import AllFillters from './Layout/AllFillters';


const AllInvoice = ({ head, data, isLoading, title }) => {

    data.sort((a, b) => {
        const dateA = new Date(a.billingDate);
        const dateB = new Date(b.billingDate);

        if (dateA < dateB) {
            return 1;
        } else if (dateA > dateB) {
            return -1;
        } else {
            return 0;
        }
    });



    return (
        <Fragment>

            <AllFillters
                title={title}
                data={data}
                filters = {[]}
            />
            <Box maxW={'full'} my={4} >
                <TableContainer height={`${window.innerHeight - 244}px`} overflowY={'scroll'}>
                    <Table variant={'simple'} size={'xs'}>
                        <Thead bgColor={'gray.100'} position={'sticky'} top={'0px'} zIndex={'99'}>
                            <Tr bgColor={'#E2DFDF'}>
                                {head.map((h, i) => (
                                    <Th key={i} fontSize={'xs'} py={3} _first={{ paddingLeft: '20px' }} color={'#25282B'}>{h}</Th>
                                ))}
                            </Tr>
                        </Thead>

                        <Tbody>
                            {(data.length > 0) ?
                                <>
                                    {data.map((d, i) => (
                                        <Tr key={i} bgColor={'white'}>
                                            <Td fontSize={'xs'} py={3} pl={5}>
                                                #{d.invoiceName || 'not available'}
                                            </Td>
                                            <Td fontSize={'xs'} py={3} >
                                                <Link to={`/tenures/order/${d.InvoiceItem[0].orderId}/tenure/${d.InvoiceItem[0].tenureId}`}>
                                                    <Text color={'blue.500'}> #{d.InvoiceItem[0]?.tenureId?.split('-')[4] || '----'}</Text>
                                                </Link>
                                            </Td>
                                            <Td fontSize={'xs'} py={3} >
                                                <Link to={`/orders/order/${d.InvoiceItem[0].orderId}`} >
                                                <Text color={'blue.500'}> {d.InvoiceItem[0]?.tenure?.orderItem?.order?.OrderName || '----'}</Text>
                                                </Link>
                                            </Td>

                                            <Td fontSize={'xs'} py={3}>{new Date(d.invoiceDate).toLocaleDateString('en-IN') || '-----'}</Td>
                                            <Td fontSize={'xs'} py={3}>{new Date(d.dueDate).toLocaleDateString('en-IN') || '-----'}</Td>
                                            <Td fontSize={'xs'} py={3}>{new Date(d.cutOffDate).toLocaleDateString('en-IN') || '-----'}</Td>
                                            <Td fontSize={'xs'} py={3}>Rs.{d.invoiceTotalPayable}</Td>
                                            <Td fontSize={'xs'} py={3}>{d.statusId === null ? '---' : (d?.statusId?.charAt(0).toUpperCase() + d?.statusId?.slice(1).toLowerCase())}</Td>
                                            {/* <Td fontSize={'xs'} py={3} >{d.paymentMode}</Td> */}
                                        </Tr>
                                    ))}
                                </>
                                :
                               
                                <Tr>
                                    <Td></Td>
                                    <Td></Td>
                                    <Td></Td>
                                    <Td></Td>
                                    <Td textAlign={'left'}>
                                    {isLoading.loading === true ?
                                        <Spinner
                                        thickness='4px'
                                        speed='0.65s'
                                        emptyColor='gray.200'
                                        color='blue.500'
                                        size='xl'
                                        mt={4}
                                    
                                    />
                                    :
                                    isLoading.error === true ? <Text fontWeight={'semibold'} color={'red.500'} >Oops we are facing some temporary issue with your request</Text> : <Text  fontWeight={'semibold'} color={'green.500'}>{`NO ${title.toUpperCase()} AVAILABLE`}</Text>
                          }
                                    </Td>
                                    <Td></Td>
                                    <Td></Td>
                                    <Td></Td>
                                    <Td></Td>
                                </Tr>
                             
                                
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </Box>
        </Fragment>
    )
}

export default AllInvoice
